<template>
  <PoeLevelBoost
    v-if="currentGamePackSlug === 'path-of-exile-2-leveling-boost'"
  />
  <PoeCurrencyBoost
    v-else-if="currentGamePackSlug === 'path-of-exile-2-currency-boost'"
  />

  <template
    v-if="
      [
        'path-of-exile-2-ascension-trials-boost',
        'path-of-exile-2-campaign-boost',
      ].includes(currentGamePackSlug)
    "
  >
    <div class="d-flex-column flex-65 justify-start align-start t-white gap-0">
      <PoeAscensionTrials
        v-if="currentGamePackSlug === 'path-of-exile-2-ascension-trials-boost'"
      />
      <PoeCampaignBoost
        v-else-if="currentGamePackSlug === 'path-of-exile-2-campaign-boost'"
      />
    </div>

    <div
      class="d-flex-column flex-2 justify-start align-start t-white cart_container"
    >
      <WhyWeCheap />
      <Cart />
      <SafeSecurePayments />
    </div>
  </template>
  <!-- PACKS HERE -->
</template>
<script setup>
import PoeLevelBoost from "../calculators/path-of-exile/PoeLevelBoost.vue";
import PoeCurrencyBoost from "../calculators/path-of-exile/PoeCurrencyBoost.vue";
import PoeAscensionTrials from "../calculators/path-of-exile/PoeAscensionTrials.vue";
import Cart from "../calculators/checkout/Cart.vue";
import SafeSecurePayments from "../calculators/checkout/SafeSecurePayments.vue";
import PoeCampaignBoost from "../calculators/path-of-exile/PoeCampaignBoost.vue";
import WhyWeCheap from "../custom/WhyWeCheap.vue";
const { currentGamePackSlug } = useGameComposable();
</script>

<style lang="scss">
@import url("/assets/scss/modules/_path-of-exile.module.scss");
</style>
